// AiAgent.js
// Purpose: Displays and manages the list of AI agents, including creating, editing, and viewing agent details.
// Logic: Uses React hooks and APIs to fetch agent data, manage state, and render agent-related UI components.

import { useEffect, useRef, useState } from "react";
import {
  Button,
  Modal,
  Drawer,
  Tabs,
  Label,
  TextInput,
  Textarea,
  Select,
  Card,
  Dropdown,
} from "flowbite-react";
import { MdWork } from "react-icons/md";
import {
  HiAdjustments,
  HiFolder,
  HiUserCircle,
  MdGroupWork,
} from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import ThreeDotsLoader from "../components/ThreeDotsLoader";
import FailureModal from "../components/FailureModal";
import useCommonApi from "../hooks/common-apis";
import { clog } from "../lib/utils";

function AiAgent() {
  const navigate = useNavigate();
  const { getKnowledgeBaseList, getAgentsData } = useCommonApi();
  const [knowLedgeBaseList, setknowLedgeBaseList] = useState([]);
  const IconProfile = () => (
    <svg className="icon w-5 h-5 me-2">
      <use href="#icon_emp"></use>
    </svg>
  );

  const IconWork = () => (
    <svg className="icon w-5 h-5 me-2">
      <use href="#icon_work"></use>
    </svg>
  );
  const IconTeam = () => (
    <svg className="icon w-5 h-5 me-2">
      <use href="#icon_team"></use>
    </svg>
  );
  const IconTools = () => (
    <svg className="icon w-5 h-5 me-2">
      <use href="#icon_tool"></use>
    </svg>
  );
  const IconIntegration = () => (
    <svg className="icon w-5 h-5 me-2">
      <use href="#icon_integration"></use>
    </svg>
  );
  const [openModal, setOpenModal] = useState(false);
  const [openModalDeploy, setOpenModalDeploy] = useState(false);
  const [employeeDetails, setemployeeDetails] = useState({
    id: "",
    subject: "",
    message: "",
  });
  const [creatingAgent, setcreatingAgent] = useState(false);
  const [getAgentData, setgetAgentData] = useState(false);
  const [agentData, setagentData] = useState([]);
  const [openSuccessModal, setopenSuccessModal] = useState(undefined);
  const [openFailureModal, setopenFailureModal] = useState(undefined);
  const [successFailureMessage, setsuccessFailureMessage] = useState("");
  const removeModal = () => {
    setopenSuccessModal(undefined);
    setopenFailureModal(undefined);
  };
  const handleChange = (e) => {
    setemployeeDetails({
      ...employeeDetails,
      [e.target.id]: e.target.value,
    });
  };

  const [isOpen, setIsOpen] = useState(false);
  const [rawFile, setrawFile] = useState(null);
  const [previewUrl, setpreviewUrl] = useState(null);
  const profilePicRef = useRef(null);

  const handleClose = () => setIsOpen(false);

  //
  const [isOpenNav, setIsOpenNav] = useState(false);

  const handleCloseNav = () => setIsOpenNav(false);
  const notify = (message, type) =>
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      type: type,
    });
  // Function to upload the icon
  const uploadIconFn = async () => {
    try {
      let formdata = new FormData();

      formdata.append("vsn_file", rawFile);

      const response = await axios({
        url: `${process.env.REACT_APP_BASE_SIGNIN_URL}/upload/files/ai-employee`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          jwt_token: localStorage.getItem("login_token"),
        },
        timeout: 10000,
        data: formdata,
      });

      if (!response.data.error) {
        return {
          error: false,
          data: response.data.file_path,
        };
      } else {
        return {
          error: true,
          data: response.data.message,
        };
      }
    } catch (error) {
      clog(error);
      return {
        error: true,
        data: error.message,
      };
    }
  };
  // Function to create or update an AI agent
  const createAgent = async () => {
    let login_data = JSON.parse(localStorage.getItem("login_data") || "{}");
    if (!login_data || Object.keys(login_data).length == 0) {
      return;
    }
    setcreatingAgent(true);
    try {
      let profile_photo = employeeDetails?.id ? previewUrl : "";
      if (rawFile) {
        let response = await uploadIconFn(rawFile);
        clog(response);
        if (!response.error) {
          profile_photo = response.data;
        } else {
          setopenFailureModal("dismissible");
          setsuccessFailureMessage(response.message);
          setcreatingAgent(false);
          return;
        }
      }
      let data = {
        emp_name: employeeDetails.subject,
        description: employeeDetails.message,
        profile_pic: profile_photo,
        type: 1, //Marketing
      };
      if (employeeDetails?.id) {
        data.id = employeeDetails.id;
      }
      let response = await axios({
        url: !employeeDetails?.id
          ? `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/ai/employee/create`
          : `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/ai/employee/update`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      if (!response.data.error) {
        notify(response?.data?.message, "success");
        if (!employeeDetails?.id) {
          localStorage.setItem(
            "selected_agent",
            JSON.stringify(response?.data?.aiEmployee)
          );
          navigate(`/ai-employee/${response?.data?.aiEmployee?.emp_name}`);
        } else {
          getAgentsDataFn();
          setrawFile(null);
          setpreviewUrl(null);
          setemployeeDetails({
            subject: "",
            message: "",
          });
          setIsOpen(false);
          setIsOpenNav(false);
        }
      } else {
        clog("Error in fetching notifications");
        // notify(response?.data?.message, "error");
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(response.message);
      }
    } catch (error) {
      clog("Error in fetching notifications", error);
      // notify(error?.response?.data?.message || error?.message, "error");
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(
        error?.response?.data?.message || error?.message
      );
      // setnotificationsUnread([]);
      if (error?.response?.status == 401 || error?.response?.status == 403) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setcreatingAgent(false);
      // setrawFile(null);
      // setpreviewUrl(null);
      // setemployeeDetails({
      //   subject: "",
      //   message: "",
      // });
      // setIsOpen(false);
      // setIsOpenNav(false);
    }
  };
  // Function to fetch AI agents data
  const getAgentsDataFn = async () => {
    setgetAgentData(true);
    try {
      let response = await getAgentsData();
      if (!response.data.error) {
        setagentData(response?.data || []);
      } else {
        clog("Error in fetching notifications");
        setagentData([]);
      }
    } catch (error) {
    } finally {
      setgetAgentData(false);
    }
  };
  // Function to fetch knowledge base list
  const getKnowLedgeBaseListFn = async () => {
    let login_data = JSON.parse(localStorage.getItem("login_data"));
    let workspace_id = login_data?.resp_user?.workspace_id;
    if (!workspace_id) {
      return;
    }
    let response = await getKnowledgeBaseList(workspace_id);
    if (response) {
      setknowLedgeBaseList(response?.data || []);
    } else {
      setknowLedgeBaseList([]);
    }
  };
  const checkKnowledgeBase = () => {
    if (knowLedgeBaseList?.length === 0) {
      // notify("Please create knowledge base first", "error");
      setopenFailureModal("dismissible");
      setsuccessFailureMessage("Please create knowledge base first");
    }
    return knowLedgeBaseList?.length > 0;
  };
  const handleChangeFileFun = (e) => {
    let file = e.target.files[0];

    setrawFile(file);
    e.target.files = null;
  };
  // Effect to set the preview URL when rawFile changes
  useEffect(() => {
    if (!rawFile) {
      // setpreviewUrl(null);
      return;
    }
    const objectURL = URL.createObjectURL(rawFile);
    setpreviewUrl(objectURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawFile]);
  // Effect to set the initial preview URL from workspaceDetail
  useEffect(() => {
    getAgentsDataFn();
    getKnowLedgeBaseListFn();
  }, []);

  return (
    <>
      <h6 className="font-[600] text-[24px]">Vison AI Employee</h6>

      <p className="font-[500] text-[16px] pt-3">
        Choose and Deploy AI Employees that Consistently Deliver Results
      </p>

      <div className="flex items-center my-[36px]">
        {/* <button
          type="button"
          className="hover:bg-[#F1FBFF] shadow-lg hover:shadow-[#03587E33] py-[8px] px-[28px] rounded-[8px] border  hover:border-[#0D78A9] me-5"
        >
          All
        </button> */}

        <button
          type="button"
          className="bg-[#F1FBFF] shadow-lg shadow-[#03587E33] py-[8px] px-[28px] rounded-[8px] border  border-[#0D78A9] me-5"
        >
          Marketing
        </button>

        {/* <button
          type="button"
          className="hover:bg-[#F1FBFF] shadow-lg hover:shadow-[#03587E33] py-[8px] px-[28px] rounded-[8px] border  hover:border-[#0D78A9] me-5"
        >
          Sales
        </button> */}

        {/* <button
          type="button"
          className="hover:bg-[#F1FBFF] shadow-lg hover:shadow-[#03587E33] py-[8px] px-[28px] rounded-[8px] border  hover:border-[#0D78A9] me-5"
        >
          Operations
        </button> */}

        {/* <button
          type="button"
          className="hover:bg-[#F1FBFF] shadow-lg hover:shadow-[#03587E33] py-[8px] px-[28px] rounded-[8px] border  hover:border-[#0D78A9] me-5"
        >
          Analyst
        </button> */}
      </div>

      <div className="flex">
        <button
          type="button"
          className="bg-[#FFFFFF] shadow-md hover:shadow-[#03587E33] max-w-sm w-full h-[300px] rounded-[30px] border  hover:border-[#0D78A9] hover:text-[#097BA9] me-[40px]"
          onClick={() => {
            if (checkKnowledgeBase()) {
              setIsOpenNav(true);
            }
          }}
        >
          <div className="flex justify-center">
            <div className="relative">
              <div className="bg-[#F1FBFF] w-[130px] h-[130px] rounded-[50%] overflow-hidden flex items-center justify-center">
                {/* <svg className="icon text-[90px]">
                  <use href="#icon_mark"></use>
                </svg> */}
              </div>
              <div className="w-[136px] absolute top-0">
                <img src="images/mark.png" alt="mark" />
              </div>
            </div>
          </div>

          <h4 className="text-[28px] font-[700] pt-5 bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] inline-block text-transparent bg-clip-text">
            Mark
          </h4>
          <p className="text-[18px] font-[600] text-[#000]">
            Our Content Marketing AI Employee
          </p>
        </button>
      </div>

      <div className="main-content mt-8">
        <div className="py-6">
          <h6 className="font-[600] text-[24px]">Deployed AI Employees</h6>
          {/* <p className="font-[500] text-[16px] pt-3">Lorem Ipsum</p> */}
          {getAgentData && (
            <div className="flex items-center justify-center">
              <Loader />
            </div>
          )}
        </div>
        {/*type 1=Marketing, 2=Sales, 3=Operation, 4=Analyst */}
        {agentData?.filter((agent) => agent?.type === 1)?.length > 0 && (
          <div className="wrapper-content my-4">
            <h6 className="font-[600] text-[16px] pb-2">Marketing</h6>

            <div className="grid grid-cols-3 gap-5 pb-6">
              {agentData
                ?.filter((agent) => agent?.type === 1)
                ?.map((agent, index) => (
                  <Card
                    className="w-[384px] min-w-[384px] shadow-md hover:shadow-[#03587E33] rounded-[30px] border  hover:border-[#0D78A9] relative cursor-pointer"
                    onClick={() => {
                      localStorage.setItem(
                        "selected_agent",
                        JSON.stringify(agent)
                      );
                      navigate(
                        `/ai-employee/${agent?.emp_name}${
                          agent?.empcontent && "?results=true"
                        }`
                      );
                    }}
                  >
                    <div className="flex  items-center">
                      <img
                        alt="agent"
                        height="60"
                        width="60"
                        src={agent?.profile_pic || "images/mark.png"}
                        className="rounded-full shadow-md object-cover w-[60px] h-[60px]"
                      />
                      <h5 className="ms-3 text-[18px] font-bold text-[#000] dark:text-white">
                        {agent?.emp_name}
                      </h5>
                    </div>
                    <div
                      className="flex items-center dot-btndrop"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <Dropdown
                        className="p-0 m-0 border-0"
                        label={
                          <svg className="icon text-[24px] text-gray-400 hover:text-black">
                            <use href="#icon_dots" />
                          </svg>
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <Dropdown.Item
                          onClick={(e) => {
                            clog("Edit clicked");
                            setemployeeDetails({
                              id: agent?.id,
                              subject: agent?.emp_name,
                              message: agent?.description,
                            });
                            setpreviewUrl(agent?.profile_pic);
                            setOpenModalDeploy(true);
                            setIsOpen(true);
                          }}
                        >
                          Edit
                        </Dropdown.Item>
                        {/* <Dropdown.Item>Inactive</Dropdown.Item> */}
                      </Dropdown>
                    </div>
                    <hr />
                    <p className="font-[500] text-[16px]">
                      {agent?.description}
                    </p>
                  </Card>
                ))}
            </div>
          </div>
        )}
        <hr />

        {/* <div className="wrapper-content my-4">
          <h6 className="font-[600] text-[16px] pb-2">Marketing</h6>
          <Card className="max-w-sm shadow-lg hover:shadow-[#03587E33] rounded-[30px] border  hover:border-[#0D78A9] relative">
            <div className="flex  items-center">
              <img
                alt="Bonnie image"
                height="60"
                width="60"
                src="images/avtar.png"
                className="mb-3 rounded-full shadow-lg"
              />
              <h5 className="ms-3 text-[18px] font-bold text-[#000] dark:text-white">
                Vineet Joshi
              </h5>
            </div>
            <div className="flex items-center dot-btndrop">
              <Dropdown
                className="p-0 m-0 border-0"
                label={
                  <svg className="icon text-[24px] text-gray-400 hover:text-black">
                    <use href="#icon_dots" />
                  </svg>
                }
              >
                <Dropdown.Item>Edit</Dropdown.Item>
                <Dropdown.Item>Inactive</Dropdown.Item>
              </Dropdown>
            </div>
            <hr />
            <p className="font-[500] text-[16px]">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent
              tempus risus et leo mattis porttitor. Suspendisse fermentum
            </p>
          </Card>
        </div> */}
        <hr />
      </div>

      {/* <Button onClick={() => setOpenModal(true)}>Toggle modal</Button> */}

      <Modal
        dismissible
        show={openModal}
        onClose={() => setOpenModal(false)}
        size="4xl"
      >
        <Modal.Header className="p-0 m-0 border-0"></Modal.Header>
        <Modal.Body>
          <div className="px-5 pb-5">
            <p className="text-center text-[18px] font-[500] pb-4">
              New to AI Employee? Deploy Instantly for Best Results
            </p>
            <button
              type="button"
              className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 mb-[30px] flex items-center justify-center"
              onClick={() => {
                navigate("/ai-agentname");
              }}
            >
              <svg className="icon text-[28px] me-3">
                <use href="#icon_deploy"></use>
              </svg>
              Deploy
            </button>
            {/* <button
              type="button"
              class="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[54px] w-full rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[20px] font-[500] mb-[40px] flex items-center justify-center"
              onClick={()=>{
                navigate('/ai-agentname')
              }}
            >
              <svg className="icon text-[28px] me-3">
                <use href="#icon_deploy"></use>
              </svg>
              Deploy
            </button> */}

            <p className="text-center text-[18px] font-[500] pb-4">
              Experienced Users: Configure and Deploy for Optimal Performance
            </p>

            {/* <button
              type="button"
              onClick={() => {
                setIsOpen(true);
                setOpenModal(false);
              }}
              class="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[54px] w-full rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[20px] font-[500] flex items-center justify-center"
            >
              <svg className="icon text-[28px] me-3">
                <use href="#icon_configure"></use>
              </svg>
              Configure Deploy
            </button> */}

            <button
              type="button"
              className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] bg-gradient-to-r hover:from-[#1A71A7] hover:to-[#9D3784] hover:text-white hover:transition hover:delay-75 flex items-center justify-center"
              onClick={() => {
                setIsOpen(true);
                setOpenModal(false);
              }}
            >
              <svg className="icon text-[28px] me-3">
                <use href="#icon_configure"></use>
              </svg>
              Configure Deploy
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Drawer
        open={isOpenNav}
        onClose={handleCloseNav}
        position="right"
        className="w-[82%] ai-empCan"
        data-testid="close-drawer"
      >
        <Drawer.Header />
        <Drawer.Items className="h-[95%] flex items-center">
          <div className="px-5 pb-5 w-full">
            <p className="text-center text-[18px] font-[500] pb-4">
              New to AI Employee? Deploy Instantly for Best Results
            </p>
            <button
              type="button"
              className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] hover:transition hover:delay-75 mb-[30px] flex items-center justify-center"
              onClick={() => {
                // navigate("/ai-agentname");
                setOpenModalDeploy(true);
                setIsOpen(true);
                setemployeeDetails({
                  id: "",
                  subject: "",
                  message: "",
                  type: 1,
                });
                setrawFile(null);
                setpreviewUrl(null);
              }}
            >
              <svg className="icon text-[28px] me-3">
                <use href="#icon_deploy"></use>
              </svg>
              Deploy
            </button>

            {/* <p className="text-center text-[18px] font-[500] pb-4">
              Experienced Users: Configure and Deploy for Optimal Performance
            </p> */}

            {/* <button
              type="button"
              className="py-2 h-[54px] w-full rounded-full text-[20px] font-semibold ring-[1px] ring-[#2A2A2A] ring-inset hover:ring-[none] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] hover:transition hover:delay-75 flex items-center justify-center"
              onClick={() => {
                setOpenModalDeploy(false);
                setIsOpen(true);
              }}
            >
              <svg className="icon text-[28px] me-3">
                <use href="#icon_configure"></use>
              </svg>
              Configure Deploy
            </button> */}
          </div>
        </Drawer.Items>
      </Drawer>

      {/*  */}

      <Drawer
        open={isOpen}
        onClose={handleClose}
        position="right"
        className="w-[82%] employee-offcan p-0"
      >
        {clog(openModalDeploy, "open modal deploy")}
        <Drawer.Header className="p-0 m-0 header-offcan" />
        <Drawer.Items className="item-content w-full">
          <Tabs
            aria-label="Default tabs"
            variant="default"
            className="tabs-top"
          >
            <Tabs.Item active title="Employee Profile" icon={IconProfile}>
              <div className="w-full ps-[60px]">
                <h4 className="text-start w-full text-[24px] font-[700]">
                  Employee Profile
                </h4>

                <div className="w-[120px] max-w-[120px] h-[120px] max-h-[120px] rounded-full flex items-center justify-center  my-[30px]">
                  {/* <img
                    src="images/avtar.png"
                    alt="user"
                    className="w-full h-full object-cover"
                  /> */}
                  <form
                    id="file-upload-form"
                    className="uploader w-[120px] h-[120px]"
                    style={{ width: "120px", height: "120px" }}
                  >
                    <input
                      id="file-upload"
                      type="file"
                      name="fileUpload"
                      accept="image/*"
                      onChange={(e) => {
                        handleChangeFileFun(e);
                      }}
                    />

                    <label
                      className="flex justify-center items-center "
                      htmlFor="file-upload"
                      id="file-drag"
                      style={{
                        width: "120px",
                        height: "120px",
                        background: previewUrl && "none",
                      }}
                      ref={profilePicRef}
                    >
                      <div id="start">
                        {previewUrl ? (
                          <div className="relative ">
                            <div className="rounded-[50%] w-[120px] h-[120px] flex items-center justify-center overflow-hidden">
                              <img
                                src={previewUrl}
                                className="w-full object-cover"
                                alt="..."
                              />
                            </div>
                            <button
                              type="button"
                              className="absolute w-[25px] h-[25px] bg-[#5DE56A] right-[5px] bottom-[5px] rounded-[50%] text-[white] hover:text-[red] icon-edit-border"
                              onClick={() => profilePicRef?.current?.click()}
                              style={{
                                borderRadius: "50% !important",
                              }}
                            >
                              <svg className="icon">
                                <use href="#icon_edit"></use>
                              </svg>
                            </button>
                          </div>
                        ) : (
                          <>
                            <svg className="icon text-[24px]">
                              <use href="#icon_upload"></use>
                            </svg>
                            <div id="notimage" className="text-sm">
                              Please select an image
                            </div>
                          </>
                        )}
                      </div>
                      <div id="response" className="hidden">
                        <div id="messages"></div>
                      </div>
                    </label>
                  </form>
                </div>

                <div className="mb-6 w-[700px]">
                  <Label
                    htmlFor="subject"
                    className="mb-2 block text-[20px] font-[400]"
                  >
                    Employee Name
                  </Label>
                  <input
                    className="border rounded-[12px] shadow-sm w-[700px] h-[50px] px-4 text-[16px] font-[400]"
                    id="subject"
                    name="subject"
                    placeholder="Enter Employee Name"
                    value={employeeDetails?.subject}
                    onChange={handleChange}
                    autoComplete="off"
                    type="text"
                  />
                </div>
                <div className="mb-6">
                  <Label
                    htmlFor="message"
                    className="mb-2 block text-[20px] font-[400]"
                  >
                    Description
                  </Label>
                  <textarea
                    className="border rounded-[12px] shadow-sm w-[700px] px-4  border-[#E9EBF0] text-[16px] font-[400]"
                    id="message"
                    name="message"
                    placeholder="Describe what this employee does"
                    rows={4}
                    value={employeeDetails?.message}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </Tabs.Item>
            {!openModalDeploy && (
              <Tabs.Item title="How Its Work" icon={IconWork}>
                This is{" "}
                <span className="font-medium text-gray-800 dark:text-white">
                  Dashboard tab's associated content
                </span>
                . Clicking another tab will toggle the visibility of this one
                for the next. The tab JavaScript swaps classes to control the
                content visibility and styling.
              </Tabs.Item>
            )}
            {!openModalDeploy && (
              <Tabs.Item title="The Team" icon={IconTeam}>
                <div className="flex">
                  <div className="left-side">
                    <ul>
                      <li>
                        <button type="button">Researcher</button>
                      </li>
                      <li>
                        <button type="button">Critics</button>
                      </li>
                      <li>
                        <button type="button">Writer</button>
                      </li>
                      <li>
                        <button type="button">Executor</button>
                      </li>
                    </ul>
                  </div>
                  <div className="right-content">
                    <h4 className="text-[24px] font-[700] pb-[12px]">
                      Researcher
                    </h4>

                    <p className="text-[18px] font-[500] pb-4">
                      This team member takes care of researching part by
                      crawling on the internet
                    </p>

                    <div className="mb-6 max-w-[90%]">
                      <label className="text-[20px] font-[400]">
                        How To Use
                      </label>
                      <div className="shadow-tab p-4 rounded-[10px] mt-4 text-[14px] font-[400]">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                        vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio
                      </div>
                    </div>
                    <div className="mb-6 max-w-[90%]">
                      <Label
                        htmlFor="approval"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Max auto runs before asking approval
                      </Label>
                      <input
                        className="border rounded-[12px] shadow-sm h-[50px] w-full px-4 text-[16px] font-[400]"
                        id="approval"
                        name="approval"
                        placeholder="Enter the number of times the tool can run before asking user approval"
                      />
                    </div>

                    <div className="mb-6 max-w-[90%]">
                      <Label
                        htmlFor="approval"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Approval Type
                      </Label>
                      <Select id="countries" required>
                        <option>
                          Choose either user approval required or not
                        </option>
                        <option>Auto Approve</option>
                        <option>User Approve</option>
                        <option>Let Employee Decide</option>
                      </Select>
                    </div>
                  </div>
                </div>
              </Tabs.Item>
            )}
            {!openModalDeploy && (
              <Tabs.Item title="Tools Used" icon={IconTools}>
                <div className="right-content">
                  <h4 className="text-[24px] font-[700] pb-[12px]">
                    Tool Used
                  </h4>

                  <div className="mb-6 max-w-[90%]">
                    <div className="shadow-tab p-4 rounded-[10px] mt-4 mb-5 text-[14px] font-[400]">
                      <p className="text-[22px] font-[600] pb-2">
                        Tool 01 Name
                      </p>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                        vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio
                      </p>
                    </div>

                    <div className="shadow-tab p-4 rounded-[10px] mt-4 mb-5 text-[14px] font-[400]">
                      <p className="text-[22px] font-[600] pb-2">
                        Tool 02 Name
                      </p>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                        vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio
                      </p>
                    </div>

                    <div className="shadow-tab p-4 rounded-[10px] mt-4 mb-5 text-[14px] font-[400]">
                      <p className="text-[22px] font-[600] pb-2">
                        Tool 03 Name
                      </p>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio Lorem
                        ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                        vitae nibh quis nisl sodales maximus. Aliquam dolor
                        orci, cursus vitae laoreet eget, tincidunt id odio
                      </p>
                    </div>
                  </div>
                </div>
              </Tabs.Item>
            )}
            {!openModalDeploy && (
              <Tabs.Item title="Integration" icon={IconIntegration}>
                <div className="right-content">
                  <h4 className="text-[24px] font-[700] pb-[12px]">
                    Integration
                  </h4>

                  <p className="text-[20px] font-[400] pb-[12px]">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Aenean fringilla placerat libero, viverra facilisis mi
                    lobortis vita
                  </p>

                  <div className="flex items-center mb-6">
                    <div className="max-w-[140px] me-4">
                      <div className="w-[100px] h-[100px] max-w-[100px] rounded-full bg-gradient-to-r from-[#5E78F4] to-[#F14CE2] flex items-center justify-center">
                        <svg className="icon text-[68px] text-[#fff]">
                          <use href="#icon_medium"></use>
                        </svg>
                      </div>
                      <p className="text-[20px] font-[700] pt-3">Medium</p>
                    </div>
                    <div className="max-w-[140px] me-4">
                      <div className="w-[100px] h-[100px] max-w-[100px] rounded-full bg-[#EFEFEF] flex items-center justify-center">
                        <svg className="icon text-[68px]">
                          <use href="#icon_wordpress"></use>
                        </svg>
                      </div>
                      <p className="text-[20px] font-[700] pt-3">Word Press</p>
                    </div>
                  </div>

                  <div className="mb-6 max-w-[60%] text-[20px] font-[400]">
                    Connect your medium account for the agent to auto publish on
                    behalf of you
                  </div>

                  <div className="mb-6 max-w-[60%] mt-[12px]">
                    <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="User"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        User Name
                      </Label>
                      <input
                        type="text"
                        className="border border-[#E9EBF0] rounded-[12px] shadow-sm w-[700px] h-[50px] px-4 text-[16px] font-[400]"
                        id="User"
                        name="User"
                        placeholder="Enter user name"
                      />
                    </div>

                    <div className="mb-6 w-[700px]">
                      <Label
                        htmlFor="Password"
                        className="mb-2 block text-[20px] font-[400]"
                      >
                        Password
                      </Label>
                      <input
                        type="password"
                        className="border border-[#E9EBF0] rounded-[12px] shadow-sm w-[700px] h-[50px] px-4 text-[16px] font-[400]"
                        id="Password"
                        name="Password"
                        placeholder="Enter password"
                      />
                    </div>
                    <div className="mb-6 w-[700px]">
                      <button
                        type="button"
                        class="bg-gradient-to-r border border-[#000000] hover:border-[transparent hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[40px] w-[700px]  transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500] rounded-full btn-radius"
                      >
                        Authenticate
                      </button>
                    </div>
                  </div>
                </div>
              </Tabs.Item>
            )}
          </Tabs>
        </Drawer.Items>

        <footer>
          <button
            type="button"
            class="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[40px] w-[200px] rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500] me-8"
            onClick={handleClose}
          >
            Cancel
          </button>

          <button
            type="submit"
            class="bg-gradient-to-r border border-[#000000] hover:border-[transparent] hover:bg-gradient-to-r hover:from-[#5E78F4] hover:to-[#F14CE2] hover:text-[#fff] h-[40px] w-[200px] rounded-full transition-all duration-300 hover:border-l-0 hover:border-r-0 text-[18px] font-[500]"
            onClick={() => {
              createAgent();
            }}
          >
            {creatingAgent ? (
              <div className="flex justify-center items-center">
                {/* <Loader /> */}
                <div>Deploying</div>
                <div>
                  <ThreeDotsLoader />
                </div>
              </div>
            ) : (
              "Deploy"
            )}
          </button>
        </footer>
      </Drawer>
      <FailureModal
        open={openFailureModal}
        removeModal={removeModal}
        successFailureMessage={successFailureMessage}
      />
    </>
  );
}

export default AiAgent;
